export default __webpack_public_path__ + "static/media/capsule-locked-large.860b4928.png";